// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  itemId: __t.string().primaryKey().name("item_id"),
  displayName: __t.string().name("display_name"),
  itemValue: __t.u32().name("item_value"),
  maxStack: __t.u32().name("max_stack"),
  itemType: __t.string().name("item_type"),
  metadataJson: __t.string().name("metadata_json"),
  inCirculation: __t.u64().name("in_circulation"),
  createdAt: __t.timestamp().name("created_at"),
});
